import { View, Text } from 'react-native'
import React, { FunctionComponent } from 'react'
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons'

import { InfoCentreType } from './InfoCentre.types'
import styles from './InfoCentre.styles'

export const InfoCentre: FunctionComponent<InfoCentreType> = ({ icon, message }) => {
  return (
          <View style={styles.container}>         
              <View style={styles.infoPlaceholder}>
                <MaterialCommunityIcons name={icon || 'data-matrix'} size={72} color="#384454" />
                <Text style={styles.infoPlaceholderText}>
                  {message}
                </Text>                
              </View>
          </View>
  );
};